// @flow
import Loadable from 'react-loadable';
import type { Options } from 'react-loadable';

import PageLoading from './PageLoading';

/**
 * Provides defaults for any component that needs to be lazy loaded
 *
 * @example
 * import PageLoader from 'components/common/loader/PageLoader'
 * const ComponentWithLoader = PageLoader({
 *   loader: () => import('component')
 * })
 */
export default function PageLoader<TProps, TModule>(
  opts: Options<TProps, TModule>
) {
  // marked as any because opts might give render() or not
  const computedOptions: any = {
    loading: PageLoading,
    ...opts
  };
  // eslint-disable-next-line new-cap
  return Loadable(computedOptions);
}



// WEBPACK FOOTER //
// ./src/components/common/loader/PageLoader.js